import React from 'react';

const Preloader = () => {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white">
      <div className="w-12 h-12 border-4 border-gray-300 border-t-[#2584C6] rounded-full animate-spin"></div>
    </div>
  );
};

export default Preloader;
